import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

export const createNewReseller = async (newUserData) => {
  if (!newUserData) return;

  try {
    const safeUserData = {
      operatingUnitId: newUserData.operatingUnitId,
      dealershipId: newUserData.dealershipId,
      email: newUserData.email,
      name: newUserData.name,
      address: newUserData.address,
      city: newUserData.city,
      personalId: newUserData.personalId,
      phone: newUserData.phone,
      requestedApp: newUserData.requestedApp || "dealership_web",
    };
    const createResellerFn = httpsCallable(functions, "createNewResellerV2");
    const result = await createResellerFn(safeUserData);
    return result.data;
  } catch (error) {
    console.error("Error creando reseller:", error);
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: error.message || "Error al crear el usuario",
      error: error.message,
    };
  }
};
